<template>
  <v-card>
    <v-dialog max-width="500px"
              persistent
              v-model="showAddTypeOfTaskDialog">
      <v-card>
        <v-toolbar color="kbLightBlue"
                   dark
                   flat>
          <v-toolbar-title>
            {{ $t(`general.${selectedType ? 'editTaskType' : 'newTypeOfTask'}`) }}
          </v-toolbar-title>

          <v-spacer/>

          <v-btn @click="close"
                 icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field :label="$t('general.typeOfTask')"
                            :rules="[rules.required]"
                            v-model="typeOfTask">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>

          <v-btn @click="close"
                 color="error"
                 dark
                 text>
            {{ $t('general.cancel') }}
          </v-btn>

          <v-btn @click="submit"
                 color="kbLightBlue"
                 dark
                 :loading="loading">
            {{ $t(`general.${selectedType ? 'edit' : 'add'}`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500px"
              persistent
              v-model="showDeleteTypeOfTaskDialog">
      <v-card color="error"
              dark>
        <v-toolbar color="error" flat>
          <v-toolbar-title>
            {{ $t('general.deleteTaskType') }}
          </v-toolbar-title>

          <v-spacer/>

          <v-btn @click="close"
                 icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col class="text-h6"
                   cols="12">
              {{ $t('general.doYouWantToDeleteThisTypeOfTask') }}
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>

          <v-btn @click="close"
                 text>
            {{ $t('general.cancel') }}
          </v-btn>

          <v-btn color="white red--text"
                 @click="deleteTypeOfTasks"
                 :loading="deletingType">
            {{ $t('general.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title class="kbDarkBlueText--text">
      {{ $t('general.typesOfTasks') }}
    </v-card-title>

    <v-row v-if="typeOfTasksItems.length === 0">
      <v-col class="text-center"
             cols="12">
        <v-icon color="red" size="30px">
          mdi-alert
        </v-icon>
        {{ $t('general.thereAreNoTypesOfTasks') }}
      </v-col>
    </v-row>

    <v-list class="pa-3 kbWhite">
      <v-list-item :key="task.id"
                   v-for="task in typeOfTasksItems">

        <v-list-item-action>
          <v-icon>
            mdi-calendar
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            {{ task.type }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-row no-gutters>
            <v-btn @click="showDeleteTypeOfTask(task)"
                   color="red"
                   icon>
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-card-text>
      <v-row>
        <v-col class="text-right"
               @click="showAddTypeOfTaskDialog = true"
               cols="12">
          <v-btn color="kbLightBlue"
                 dark
                 rounded>
            {{ $t('general.addTaskType') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import usersTasksService from '@/services/usersTasksService'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'

export default {
  created () {
    this.getTypeOfTasks()
  },
  data: () => ({
    deletingType: null,
    loading: false,
    rules,
    selectedType: null,
    showAddTypeOfTaskDialog: false,
    showDeleteTypeOfTaskDialog: false,
    typeOfTask: '',
    typeOfTasksItems: []
  }),
  methods: {
    async submit () {
      try {
        this.loading = true
        await this.createTypeOfTask()
        this.close()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    close () {
      this.selectedType = null
      this.typeOfTask = ''
      this.showAddTypeOfTaskDialog = false
      this.showDeleteTypeOfTaskDialog = false
    },
    async createTypeOfTask () {
      if (!this.typeOfTask) return notifications.error(this.$t('general.typeMustNotBeEmpty'))

      const app = this.$store.getters.appUuid
      const company = this.$store.getters.companyUuid

      const data = {
        type: this.typeOfTask
      }

      await usersTasksService.createTypeOfTask(company, app, data)
      await this.getTypeOfTasks()

      notifications.success(this.$t('general.taskTypeCreatedSuccessfully'))
    },
    async deleteTypeOfTasks () {
      try {
        this.deletingType = true
        const app = this.$store.getters.appUuid
        const company = this.$store.getters.companyUuid

        const data = {
          id: this.selectedType.id
        }

        await usersTasksService.deleteTypeOfTasks(company, app, data)

        notifications.success(this.$t('general.taskTypeRemovedSuccessfully'))
        await this.getTypeOfTasks()
        this.deletingType = false
        this.close()
      } catch (e) {
        notifications.error(e.message)
        this.deletingType = false
      }
    },
    async getTypeOfTasks () {
      try {
        const app = this.$store.getters.appUuid
        const company = this.$store.getters.companyUuid

        const response = await usersTasksService.getTypeOfTasks(company, app)
        this.typeOfTasksItems = response.rows
      } catch (e) {
        console.log(e.message)
      }
    },
    showDeleteTypeOfTask (type) {
      this.selectedType = type
      this.showDeleteTypeOfTaskDialog = true
    }
  }
}
</script>
